module.exports = "/assets/data/444ff10b471fc39fa1133254fdeb7997-SY10.data.json";